import React from 'react';

import { fixDecimals } from '../../../helpers/helpers';
import DistanceGraph from '../../Shared/Graphics/DistanceGraphV2';
import { SHOW_DISTANCE_GRAPHS } from '../../../config/constants';
import { DistanceGraphOnRow } from './types';

export default ({ 
  totalDis, showDistanceGraphs, maxDistance, dataDistanceGraph 
} : DistanceGraphOnRow) => {
  return (
    <>
      <div className="distance-graph-div">
        <DistanceGraph
          data={dataDistanceGraph}
          colors={['#00501E', '#4F9300', '#FB8C00', '#F45110', '#D6151c']}
          width={570}
          height={20}
          onRow
          total={maxDistance}
        />
        <div className="ex-07" style={{ width: '300px' }}>
          <p style={{ padding: '7px 0px 7px 40px', textAlign: 'left' }}>
            {JSON.stringify(showDistanceGraphs) === JSON.stringify(SHOW_DISTANCE_GRAPHS.types[0]) ?
              <>TOTAL DISTANCE (YDS) <span>{fixDecimals(totalDis, 0)}</span></> :
              JSON.stringify(showDistanceGraphs) === JSON.stringify(SHOW_DISTANCE_GRAPHS.types[1]) ?
                <>HARD EFFORT DISTANCE
                  (YDS) <span>{fixDecimals(dataDistanceGraph.reduce((result, data) => (result + +data), 0), 0)}</span></> :
                JSON.stringify(showDistanceGraphs) === JSON.stringify(SHOW_DISTANCE_GRAPHS.types[2]) ?
                  <>TOTAL RUN
                    (YDS) <span>{fixDecimals(dataDistanceGraph.reduce((result, data) => (result + +data), 0), 0)}</span></> :
                  JSON.stringify(showDistanceGraphs) === JSON.stringify(SHOW_DISTANCE_GRAPHS.types[3]) ?
                    <>TOTAL SPRINT
                      (YDS) <span>{fixDecimals(dataDistanceGraph.reduce((result, data) => (result + +data), 0), 0)}</span></> :
                    <>TOTAL MAX SPRINT
                      (YDS) <span>{fixDecimals(dataDistanceGraph.reduce((result, data) => (result + +data), 0), 0)}</span></>}
          </p>
        </div>
      </div>
    </>
  );
};
